module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-b.4efba53b.jpg";